import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressIndicator = ({ currentStep, totalSteps, steps }) => {
  return (
    <div className="w-full mb-8 md:mb-10 lg:mb-12">
      <div className="flex items-center justify-between mb-4">
        {steps?.map((step, index) => (
          <React.Fragment key={step?.id}>
            <div className="flex flex-col items-center flex-1">
              <div
                className={`w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 rounded-full flex items-center justify-center transition-all duration-300 ${
                  index < currentStep
                    ? 'bg-gradient-to-br from-[var(--color-primary)] to-[var(--color-secondary)]'
                    : index === currentStep
                    ? 'bg-gradient-to-br from-[var(--color-primary)] to-[var(--color-secondary)] ring-4 ring-[var(--color-primary)]/20'
                    : 'bg-[var(--color-muted)]'
                }`}
              >
                {index < currentStep ? (
                  <Icon name="Check" size={20} color="#FFFFFF" />
                ) : (
                  <span className="text-sm md:text-base lg:text-lg font-semibold text-[var(--color-foreground)]">
                    {index + 1}
                  </span>
                )}
              </div>
              <span className="mt-2 text-xs md:text-sm text-center text-[var(--color-muted-foreground)] hidden md:block">
                {step?.label}
              </span>
            </div>
            {index < steps?.length - 1 && (
              <div className="flex-1 h-1 mx-2 bg-[var(--color-muted)] relative">
                <div
                  className="absolute top-0 left-0 h-full bg-gradient-to-r from-[var(--color-primary)] to-[var(--color-secondary)] transition-all duration-500"
                  style={{ width: index < currentStep ? '100%' : '0%' }}
                />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
      <div className="md:hidden text-center">
        <span className="text-sm text-[var(--color-muted-foreground)]">
          {steps?.[currentStep]?.label}
        </span>
      </div>
    </div>
  );
};

export default ProgressIndicator;